// components/onboarding/IntegrationCard.js
import React from 'react';
import { CheckCircle, Lock } from 'lucide-react';

const IntegrationCard = ({ 
  integration, 
  onConnect, 
  isConnecting,
  configurationContent
}) => {
  const { 
    id, 
    name, 
    description, 
    icon: Icon, 
    status, 
    color
  } = integration;

  const isConnected = status === 'connected';
  const isComingSoon = status === 'coming-soon';
  const isDisabled = isComingSoon || isConnecting;

  return (
    <div 
      className={`
        bg-white border-2 rounded-xl p-6 transition-all
        ${isConnected ? 'border-green-200 bg-green-50' : 'border-gray-200'}
        ${isComingSoon ? 'opacity-60' : ''}
        ${!isConnected && !isComingSoon ? 'hover:border-purple-300 hover:shadow-md' : ''}
      `}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div 
            className={`
              w-12 h-12 rounded-lg flex items-center justify-center text-white
              ${color}
              ${isComingSoon ? 'opacity-50' : ''}
            `}
          >
            <Icon className="w-6 h-6" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{name}</h3>
            {isConnected && (
              <span className="inline-flex items-center text-xs text-green-700 font-medium">
                <CheckCircle className="w-3 h-3 mr-1" />
                Connected
              </span>
            )}
            {isComingSoon && (
              <span className="inline-flex items-center text-xs text-gray-500 font-medium">
                <Lock className="w-3 h-3 mr-1" />
                Coming Soon
              </span>
            )}
          </div>
        </div>
      </div>

    {/* Description */}
<p className="text-sm text-gray-600 mb-4 min-h-[40px]">
  {description}
</p>

{/* Configuration Content (for Trustpilot) */}
{configurationContent ? (
  configurationContent
) : (
  <>
    {/* Action Button */}
    {!isComingSoon && (
      <button
        onClick={() => onConnect(integration)}
        disabled={isDisabled || isConnected}
        className={`
          w-full py-2 px-4 rounded-lg font-medium text-sm transition-colors
          ${isConnected 
            ? 'bg-green-100 text-green-800 cursor-default' 
            : 'bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed'
          }
        `}
      >
        {isConnecting === id
          ? 'Connecting...'
          : isConnected 
            ? 'Connected ✓' 
            : 'Connect Now'
        }
      </button>
    )}

    {isComingSoon && (
      <div className="w-full py-2 px-4 rounded-lg bg-gray-100 text-gray-500 text-sm font-medium text-center">
        Coming Soon
      </div>
    )}
  </>
)}
    </div>
  );
};

export default IntegrationCard;